import React from "react";
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
    isSimilarObject,
    getDateTime,
    UTCToLocal,
    orderStatusesObj
} from '../helper';
import {
    FacebookShareButton,
    TwitterShareButton,
    VKShareButton,
} from 'react-share';

class OrdersListItem extends React.Component {

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {

        const props = this.props;
        let status = orderStatusesObj[props.status];
        const id = props.id;
        const isCustomer = (props.currentUserId === props.user_id);

        let likeTitle = 'Проголосовать могут только зарегистрированные пользователи';
        if(props.isLoggedIn) likeTitle = "Проголосовать";
        if(props.is_already_liked) likeTitle = 'Вы проголосовали +1';
        if(props.is_already_disliked) likeTitle = 'Вы проголосовали -1';
        let statusColor = '#8e8e8e';
        if(props.status === 4) statusColor = '#fe3738';
        if(props.status === 3) statusColor = '#f9b53e';
        if(props.status === 1 || props.status === 2 || props.status === 9) statusColor = '#64ab15';

        let startDateTime = getDateTime(props.order_date_at, props.order_time_at);
        // let endDateTime = getDateTime(props.order_date_at, props.order_time_end_at);
        let endDateTime = getDateTime(props.order_date_end_at?props.order_date_end_at:props.order_date_at, props.order_time_end_at);
        let startLocalDateTime = UTCToLocal(startDateTime.dateTime);
        let endLocalDateTime = UTCToLocal(endDateTime.dateTime);

        return(
            <li className="list-item">
                <div className="top">
                    <div className="order-name-block">
                        {
                            ((isCustomer || props.is_my_bid) || (props.status > 2))
                            ?
                            <Link to={`/makeorder/${id}`} className={`caption ${props.is_public ? 'caption-is_public' : ''}`} style={{color:statusColor}}>
                                {`№${props.id} ${props.title} (${props.address_text})`}
                            </Link>
                            :
                            <Link to={`/orders/execute/${id}`} className={`caption ${props.is_public ? 'caption-is_public' : ''}`} style={{color:statusColor}}>
                                {`№${props.id} ${props.title} (${props.address_text})`}
                            </Link>
                        }

                        {props.is_public ? <div className="tag-oval">Общедоступный</div> : null}
                    </div>
                    {
                        props.is_test
                        ? <div className="price">Тестовый заказ</div>
                        : <div className="price"><span>{`${props.price}`}</span><span style={{marginLeft:'3px'}}>р.</span></div>
                    }
                </div>
                <div style={{marginBottom:'10px'}}>

                    {
                        props.order_date_end_at
                        ? 
                        <span className="orders-item-style" style={{fontSize: '11px', marginRight: '30px',fontFamily: 'Helvetica',fontSize: '18px',color:'#383838'}}>
                            <span>С {moment(startLocalDateTime).format("DD.MM.YYYY")} : {moment(startLocalDateTime).format("HH:mm")}</span>
                            <span style={{marginLeft:'20px'}}>до {moment(endLocalDateTime).format("DD.MM.YYYY")} : {moment(endLocalDateTime).format("HH:mm")}</span>
                        </span> 
                        :
                        <span className="orders-item-style" style={{fontSize: '11px', marginRight: '30px',fontFamily: 'Helvetica',fontSize: '18px',color:'#383838'}}>
                            <span>Дата {moment(startLocalDateTime).format("DD.MM.YYYY")}</span>
                            <span style={{marginLeft:'20px'}}>c {moment(startLocalDateTime).format("HH:mm")}, до {moment(endLocalDateTime).format("HH:mm")}</span>
                        </span>
                    }

                    {
                        props.is_test
                        ?
                        <span className="orders-item-style" style={{fontSize: '11px', marginRight: '30px',fontFamily: 'Helvetica',fontSize: '18px',color:'#383838'}}>
                        Тестовый заказ не имеет время исполнения, заказчика, и цены.
                        </span>
                        : null
                    }
                </div>
                <div className="order-list__desc">
                    <p className="order-list__text" style={{whiteSpace: 'pre-line'}}>{props.content}</p>
                    {
                        props.is_my_bid && (props.my_bid_status || props.my_bid_status === 0)
                        ?
                        props.my_bid_status === 6 || props.my_bid_status === 7
                        ?
                        <div className="order-list__state order-list__state-cancel">Ваш отклик отклонен</div>
                        :
                        <div className="order-list__state">Вы откликнулись</div>
                        : ''
                    }
                </div>
                <div className="actions bottom">
                    <div className="social-activity">
                        {
                            (props.is_already_liked || props.is_already_disliked) || !props.isLoggedIn ?
                            [
                                <div key='1' className="social-activity__item like like-disabled" title={likeTitle}>{props.likes_count}</div>,
                                <div key='2' className="social-activity__item dislike dislike-disabled" title={likeTitle}>{props.dislikes_count}</div>
                            ]
                            :
                            [
                                <div key='1' className="social-activity__item like" onClick={props.handleLike} title={likeTitle}>{props.likes_count}</div>,
                                <div key='2' className="social-activity__item dislike" onClick={props.handleDislike} title={likeTitle}>{props.dislikes_count}</div>
                            ]
                        }

                        {
                            props.status > 0 ?
                            <div className="social-activity__item share" title="Поделиться">
                                <div className="social-icons">
                                    <VKShareButton className="sc-vk" url={`${window.location.origin}/orders/execute/${id}`} />
                                    {/* <GooglePlusShareButton className="sc-gl" url={`${window.location.origin}/orders/execute/${id}`} /> */}
                                    <TwitterShareButton className="sc-tw" url={`${window.location.origin}/orders/execute/${id}`} />
                                    <FacebookShareButton className="sc-fb" url={`${window.location.origin}/orders/execute/${id}`} />
                                </div>
                            </div>
                            : null
                        }

                        <div className="social-activity__item duplicate" title="Количество повторных использований">{props.duplicates_count}</div>
                    </div>

                    <div className="item-rigth">
                    {
                        props.is_failed
                        ? <div className={`text_orange status`}>Отменен</div>
                        : <div className="status" style={{color:statusColor}}>{status}</div>
                    }


                    {
                            ((isCustomer || props.is_my_bid) || (props.status > 2))
                            ?
                            <Link className="small-button" to={`/makeorder/${id}`}>
                                <button>Подробнее</button>
                            </Link>
                            :
                            <Link className="small-button" to={`/orders/execute/${id}`}>
                                <button>Подробнее</button>
                            </Link>
                        }

                    </div>

                </div>
            </li>
        )
    }

}

export default OrdersListItem;


// WEBPACK FOOTER //
// ./src/components/OrdersListItem.js